import { PaymentIntentCaptureMethod } from "@app/payment";

export const CheckoutSessionDefaultCaptureMethod = PaymentIntentCaptureMethod.AutomaticAsync;
